import Input from "../../components/input";
import Button from "../../components/button";
import { Table } from "../../components/ui/table";
import SortIcon from "../../components/icons/sort-icon";
import { useEffect, useState } from "react";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import CardDetail from "../../components/cardDetail/cardDetail";
import {
  getTransactionHistory,
  getTransectionHistoryCount,
} from "src/firebase/admin.js";
import Loader from "../../components/loader";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import { exportToExcel } from "react-json-to-excel";
import { useTranslation } from "react-i18next";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";
import { useParams } from "react-router-dom";

const pageSize = 200;

const SupplierPaymentInfo = () => {
  const [activeDeletedId, setActiveDeletedId] = useState<string>("");
  const [activeCardId, setActiveCardId] = useState<string>("");
  const [transectionHistory, setTransectionHistory] = useState([]);
  const [filterTransectionHistory, setFilterTransectionHistory] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [calenderValue, setCalenderValue] = useState(null);
  const [isShowCalender, setIsShowCalender] = useState<boolean>(false);
  const [totalCards, setTotalCards] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");
  const { t } = useTranslation(["home"]);

  const { id } = useParams();
  console.log("id", id);

  useEffect(() => {
    getTransectionList();
  }, [currentPage, searchText, id]);

  useEffect(() => {
    getTransectionListCount();
  }, [id]);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const getTransectionListCount = async () => {
    let _data: any = localStorage.getItem("account");

    _data = JSON.parse(_data);
    const _id = id ? id : _data?.id;
    let result = await getTransectionHistoryCount(_id);
    setTotalCards(result);
  };

  const getTransectionList = async () => {
    setIsLoading(true);
    let _data: any = localStorage.getItem("account");

    _data = JSON.parse(_data);
    const _id = id ? id : _data?.id;

    let result = await getTransactionHistory(
      currentPage,
      pageSize,
      searchText,
      _id,
      "id"
    );
    setIsLoading(false);
    setTransectionHistory(result ?? []);
    setFilterTransectionHistory(result ?? []);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };
  const columns = [
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Card Number")}</span>
        </div>
      ),
      dataIndex: "cardNo",
      key: "cardNo",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Amount")}</span>
        </div>
      ),
      dataIndex: "amount",
      key: "amount",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")}</span>
        </div>
      ),
      dataIndex: "transectionDate",
      key: "transectionDate",
      render: (date: any) => (
        <div>
          {date ? moment(date.seconds * 1000).format("YYYY MM,DD, HH:mm") : ""}
        </div>
      ),
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Payout status")}</span>
        </div>
      ),
      dataIndex: "payoutStatus",
      key: "payoutStatus",
      width: 200,
      render: (payoutstatus: string) => <div>{payoutstatus ?? "-"}</div>,
    },
  ];

  const handleExportData = () => {
    const _data = filterTransectionHistory.map((item) => ({
      Time: item.transectionDate
        ? moment(item.transectionDate.seconds * 1000).format("MMMM/DD, HH:mm")
        : "",
      Supplier: item?.account?.firstName + " " + item?.account?.lastName,
      Amount: item?.amount,
      Order: item?.order,
      Rate: item?.rate,
      cardNo: item?.cardNo,
    }));
    exportToExcel(_data, "transactionHistory");
  };

  const handleCalenderChange = (value) => {
    setCalenderValue(value);

    const _data = transectionHistory.filter((item) =>
      item?.transectionDate
        ? new Date(item.transectionDate.seconds * 1000).getTime() >=
            value[0].getTime() &&
          new Date(item.transectionDate.seconds * 1000).getTime() <=
            value[1].getTime()
        : false
    );
    setFilterTransectionHistory([..._data]);
    setIsShowCalender((prev) => !prev);
  };

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Payment Information")}
        </h2>
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-bold ">{t("")} </h1>
          <div className="flex gap-2 items-center">
            {/* <div className="relative">
              <Button
                className="h-[35px]"
                onClick={() => setIsShowCalender((prev) => !prev)}
              >
                {t("Calender filter")}
              </Button>
              {isShowCalender && (
                <div className="absolute top-[40px] z-10">
                  <Calendar
                    selectRange={true}
                    value={calenderValue}
                    onChange={handleCalenderChange}
                  />
                </div>
              )}
            </div> */}
            <Button className="h-[35px]" onClick={handleExportData}>
              {t("Export CSV")}
            </Button>

            <Input
              name="keyword"
              placeholder={t("Search by keyword")}
              inputClassName="h-9"
              variant="solid"
              onChange={(e) => handleSearch(e.target.value)}
            />

            {/* <Button
              className="h-[35px] bg-transparent !border !border-blue !text-blue"
              onClick={() => {
                setCalenderValue(null);
                setFilterTransectionHistory(transectionHistory);
              }}
            >
              {t("Clear")}
            </Button> */}
          </div>
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText="No data found"
          data={filterTransectionHistory}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        <Pagination
          className="w-full mt-10"
          page={currentPage}
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        />
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId("")}
      >
        <ConfirmationCard
          title="Delete This Item?"
          onCancel={() => setActiveDeletedId("")}
          onDelete={() => {}}
          description="Are you sure about deleting this card? This cannot be undone."
        />
      </Modal>
      <Modal
        open={activeCardId ? true : false}
        onClose={() => setActiveCardId("")}
        modalClass="w-full"
      >
        <CardDetail />
      </Modal>
    </div>
  );
};
export default SupplierPaymentInfo;
